import axios from "../common/AuthInterceptor";
import authHeader from "./auth-header";

const CLIENT_API_URL = process.env.REACT_APP_API_URL + "/api/client/";

const getPhotoBaseMediaSettings = (clientId) => {
  return axios.get(CLIENT_API_URL + clientId + "/mobile/media-settings", { headers: { ...authHeader() } });
};

const savePhotoBaseMediaSettings = (clientId, settings) => {
  return axios.post(CLIENT_API_URL + clientId + "/mobile/media-settings", settings, { headers: { ...authHeader() } });
};

const searchClients = (searchTerm) => {
  return axios.get(
    `${CLIENT_API_URL}search-clients?searchTerm=${encodeURIComponent(searchTerm)}`,
    { headers: authHeader() }
  );
};

const clientService = {
  getPhotoBaseMediaSettings,
  savePhotoBaseMediaSettings,
  searchClients
};

export default clientService;